module.exports = __webpack_public_path__ + "static/img/detail2.e38d9bbe.png";